<app-header></app-header>
<app-botao-chat></app-botao-chat>
<app-loading-generico [loadingGenerico]="alertLoading"></app-loading-generico>
<app-success-generico [successGenerico]="alertSucesso" (alertFechou)="fecharAlertSucesso($event)"></app-success-generico>
<app-error-generico [errorGenerico]="alertError" (alertErrorFechou)="fecharAlertError($event)"></app-error-generico>
<app-confirma-exclusao [confirmaExclusao]="alertConfirmacao" (confirmaExclusaoFechou)="fecharAlertConfirmacao($event)"></app-confirma-exclusao>


<div class="container py-4">
  <div class="row">
    <div class="col-12">
      <div class="card">
        <app-breadcrumb></app-breadcrumb>
        <h1 class="titulo">Endereços Inativos</h1>
        <p class="paragrafo mb-4">Ative-o para poder usá-lo novamente</p>

        @if (enderecosInativos && enderecosInativos?.length) {
          <div class="col-12">
            <div class="row border-top border-bottom pt-3 pb-0">
              <div class="coluna-endereco">
                <span class="label">ENDEREÇO</span>
              </div>
              <div class="coluna-lixeira">
                <span class="label">ATIVAR</span>
              </div>
            </div>
            @for (endereco of enderecosInativos; track endereco) {
              <div class="row border-top pt-3 pb-0">
                <div class="coluna-endereco">
                  <p class="paragrafo">{{endereco.fullDescription | camelCase}}</p>
                </div>
                <div class="coluna-lixeira">
                  <button
                    class="btn p-0 border-0 bg-transparent"
                    id="btnAtivarEndereco"
                    (click)="abrirAlertConfirmacao(endereco.idEndereco)"
                    title="Ativar endereço"
                    aria-label="Ativar endereço">
                    <i class="fa fa-check c-primary" aria-hidden="true"></i>
                  </button>
                </div>
              </div>
            }
          </div>
        }

        <!-- CARREGAMENTO EMPRESAS -->
        @if (enderecosInativos === null) {
          <div>
            <div class="text-center">
              <output class="spinner-border c-primary">
                <span class="visually-hidden">Consultando endereços inativos ...</span>
              </output>
            </div>
            <p class="legenda-spinner">Consultando endereços inativos ...</p>
          </div>
        }

        <!-- CASO DE ERRO EMPRESAS -->
        @if (enderecosInativos === false) {
          <div class="text-center">
            <img src="/assets/img/erro.png" width="230px" alt="Erro">
            <p class="legenda-erro">Ocorreu um erro na consulta de endereços inativos.</p>
          </div>
        }

        <!-- CASO DE ERRO EMPRESAS -->
        @if (enderecosInativos === undefined) {
          <div class="text-center">
            <img src="/assets/img/vazio.png" width="230px" alt="nao existem enderecos inativos">
            <p class="legenda">Não existem endereços inativos.</p>
          </div>
        }

        <div class="row d-flex justify-content-center text-center py-3">
          <button class="botao-outline mt-4 mx-auto botao-ajuste" id="btnCancelar" (click)="voltarAbaEnderecos()">CANCELAR</button>
        </div>

      </div>
    </div>
  </div>
</div>

<app-footer></app-footer>
